import axios from "axios";
import store from "../store/index";
import axiosUrl from "./axios.service";
const API_URL = axiosUrl.getAxiosUrl();

class AIService {
  async getAISettings() {
    return await axios
      .get(API_URL + `aisettings/getAISettings`)
      .then(response => {
        store.commit("aiSettings/setSettings", response.data);
      })
      .catch(error => {
        if (error) {
          store.commit("aiSettings/updateModalError", error.response.data),
            store.commit("aiSettings/enableModalError");
        }
      });
  }

  async updateAISettings(settings) {
    return await axios
      .post(API_URL + `aisettings/updateSettings`, {
        introTextDutch: settings.introTextDutch,
        introTextGerman: settings.introTextGerman,
        helpTextDutch: settings.helpTextDutch,
        helpTextGerman: settings.helpTextGerman,
        globalRateLimiting: settings.globalRateLimiting
      })
      .catch(error => {
        if (error) {
          store.commit("aiSettings/updateModalError", error.response.data),
            store.commit("aiSettings/enableModalError");
        }
      });
  }

  async getMessagesByConversation(conversationId) {
    return await axios
      .get(API_URL + "aiAssistantLogs/getMessagesFromConversation", {
        params: {
          conversationId: conversationId
        }
      })
      .then(response => {
        store.commit(
          "aiAssistantLogs/setMessagesFromSelectedConversation",
          response.data
        );
      })
      .catch(error => {
        if (error) {
          store.commit("aiSettings/updateModalError", error.response.data),
            store.commit("aiSettings/enableModalError");
        }
      });
  }

  // PBI 11217: read-only (GET only). Clears the previous conversation first and resolves to false on an error, so the
  // feedback popup never opens with another conversation's feedback. The thumbs-down reason options (labels from the
  // server, as in the chat) are loaded with the first feedback view.
  async getFeedbackMessagesByConversation(conversationId) {
    store.commit("aiAssistantLogs/setFeedbackMessagesFromSelectedConversation", []);

    const requests = [
      axios
        .get(API_URL + "aiAssistantLogs/getFeedbackMessagesFromConversation", {
          params: {
            conversationId: conversationId
          }
        })
        .then(response => {
          store.commit(
            "aiAssistantLogs/setFeedbackMessagesFromSelectedConversation",
            response.data
          );
        })
    ];

    if (store.state.aiAssistantLogs.thumbsDownReasonOptions === null)
      requests.push(this.getThumbsDownReasons());

    return await Promise.all(requests)
      .then(() => true)
      .catch(error => {
        store.commit("aiSettings/updateModalError", error?.response?.data);
        store.commit("aiSettings/enableModalError");
        return false;
      });
  }

  async getThumbsDownReasons() {
    return await axios
      .get(API_URL + "aiAssistantLogs/getThumbsDownReasons")
      .then(response => {
        store.commit(
          "aiAssistantLogs/setThumbsDownReasonOptions",
          response.data ?? []
        );
      });
  }

  async exportModerationLogs() {
    return await axios.get(API_URL + "aiAssistantLogs/exportModerationLogs", {
      responseType: "blob"
    });
  }

  async exportAnalyticsLogs() {
    return await axios.get(API_URL + "aiAssistantLogs/exportAnalyticsLogs", {
      responseType: "blob"
    });
  }

  async exportRateLimitLogs() {
    return await axios.get(API_URL + "aiAssistantLogs/exportRateLimitLogs", {
      responseType: "blob"
    });
  }

  async getAICustomers() {
    return await axios
      .get(API_URL + "customers/getAICustomersList")
      .then(response => {
        store.commit("customers/updateAICustomersList", response.data);
      })
      .catch(error => {
        if (error) {
          store.commit("aiSettings/updateModalError", error.response.data),
            store.commit("aiSettings/enableModalError");
        }
      });
  }

  async getAIUsers() {
    return await axios
      .get(API_URL + "users/getAIUsersList")
      .then(response => {
        store.commit("user/updateAIUsersList", response.data);
      })
      .catch(error => {
        if (error) {
          store.commit("aiSettings/updateModalError", error.response.data),
            store.commit("aiSettings/enableModalError");
        }
      });
  }
}

export default new AIService();
